import React, { useContext } from 'react';
import { Offcanvas } from 'react-bootstrap';
import { ContextToggle } from '../context/ContextToggle';
import { useBranding } from '../context/BrandingContext';
import ModernLinks from './ModernLinks';
import './ModernSidebar.css';

const ModernSidebar = () => {
  const { show, handleClose } = useContext(ContextToggle);
  const { companyName, logoUrl } = useBranding();
  const links = JSON.parse(localStorage.getItem('menu'));

  return (
    <Offcanvas 
      show={show} 
      onHide={handleClose} 
      className="modern-sidebar"
      backdropClassName="modern-sidebar-backdrop"
    >
      <Offcanvas.Header className="modern-sidebar-header">
        <div className="sidebar-brand">
          <div className="brand-icon">
            {logoUrl ? (
              <img src={logoUrl} alt={companyName} className="brand-logo-img" />
            ) : (
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="currentColor"/>
              </svg>
            )}
          </div>
          <h3 className="brand-title">{companyName}</h3>
        </div>
        <button 
          className="close-btn" 
          onClick={handleClose}
          aria-label="Cerrar menú"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </Offcanvas.Header>
      
      <Offcanvas.Body className="modern-sidebar-body">
        <nav className="sidebar-nav">
          <ModernLinks links={links} onLinkClick={handleClose} />
        </nav>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ModernSidebar;
